import { useContext } from 'react'
import {
  GlobalStateContext,
  IGlobalStateContext,
} from '../providers/GlobalStateProvider'

export default function useGlobalState(): IGlobalStateContext {
  return useContext(GlobalStateContext)
}
